import { Person } from "..";
import { QueovalBase } from "../global";


export class IdNameBase {
  public Id: string;
  public Name: string;
}

export class MyCompanyFilesModel extends QueovalBase {
  public IdStorage: string;
  public IdGroup: string;
  public IdDonnee: string;
  public Value: string;
  public ListInfoStoragePublisherDto: Array<MyCompanyFilesInfoStoragePublisherDto>;
  public ListGroup: Array<IdNameBase>;
  public ListArbo: Array<MyCompanyFilesArbo>;
  public Contacts: Array<MyCompanyFilesCustomerUser>;
}

export class MyCompanyFilesInfoStoragePublisherDto extends IdNameBase {
  public GroupId: string;
  public Value: string;
  public Access: string;
}

export class MyCompanyFilesArbo extends IdNameBase {
  public Content: Array<string>;
}

export class MyCompanyFilesAttribute {
  constructor(pName: string = '', pValue: string = '') {
    this.Name = pName;
    this.Value = pValue;
  }
  public Name: string;
  public Value: string;
}

export class MyCompanyFilesQueovalAttribute extends MyCompanyFilesAttribute {
  constructor(pName: string = '', pValue: string = '', pCodeQvl = '') {
    super(pName, pValue);
    this.CodeQvl = pCodeQvl;
  }
  public CodeQvl: string;
  public Selected: boolean;
}

export class MyCompanyFilesAddStorage {
  public AccessToken: string;
  public Name: string;
  public ListArboId: Array<number>;
  public GroupeId: number;
  public ListAttribute: Array<MyCompanyFilesAttribute>;
  public ListCustomerUser: Array<MyCompanyFilesCustomerUser>;
  public ListProviderUser: Array<string>;
  public GroupCollabId: number;
  public ListServiceId: Array<number>;
}

export class MyCompanyFilesStorage extends MyCompanyFilesAddStorage {
  public StorageId: string;
}

export class MyCompanyFilesUpload {
  public relDocumentClient: string;
  public IdDocuments: Array<string>;
  public UpdateEtatDoc: boolean;
  public notify: boolean;
}

export class MyCompanyFilesCustomerUser {
  public FirstName: string;
  public LastName: string;
  public Email: string;
  public Initials: string;
  public Password: string;
  public IsFr: boolean;
  public ListServiceId: Array<number>;
  public SendMail: boolean;
  public ListArboId: Array<number>;
}

